

















































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class RoundCancel extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly userSearch!: any;

  @Prop() readonly openModalTracking!: Function

  @Prop() readonly handleModalRoundDetail!: Function

  utilsInstance = utils;

  handleModalCancel(items, typeModal) {
    this.openModalTracking(items, typeModal);
  }

  openRoundTracking(item) {
    this.handleModalRoundDetail(item);
  }
}
